import { FullPoolLine, PartialLine } from '../../logic/pools/process-pools'
import { TokenWithData } from '../../api/api-types'

export interface IPoolColumn {
  Header: string
  accessor: string
  Cell: (e: any) => JSX.Element
}

export interface TableLine extends PartialLine {
  buttons: any[]
  composition: TokenWithData[]
}

export type BooleanSetter = (b: boolean) => void

export interface PoolTableButton {
  message: string
  action: VoidFunction
  pool: PartialLine
}

export function getButtonsPerPool(
  pool: PartialLine,
  onDeposit: VoidFunction,
  onWithdraw: VoidFunction
): PoolTableButton[] {
  let shares = pool.userValue
  let hasShares = false
  if (shares && Number(shares) > 0) {
    hasShares = true
  }

  const deposit: PoolTableButton = {
    message: 'Deposit',
    pool,
    action: onDeposit,
  }
  const withdraw: PoolTableButton = {
    message: 'Withdraw',
    pool,
    action: onWithdraw,
  }

  return hasShares ? [deposit, withdraw] : [deposit]
}
